import { useEffect, useState } from "react";
import { fetchDailyInsight } from "@/lib/api";
import { Quote, Sparkles } from "lucide-react";

export default function DailyInsight() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchDailyInsight()
      .then((d) => { if (alive) setData(d); })
      .catch((err) => { console.warn("Daily insight fetch failed:", err); })
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <section className="relative bg-cream border-y border-gold/30 py-14 md:py-20 overflow-hidden grain" data-testid="daily-insight">
      <div className="max-w-5xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 md:gap-16">
        <div className="relative">
          <span className="label-overline">Today's quote</span>
          <Quote className="absolute -top-2 -left-2 text-gold/30" size={56} strokeWidth={1} />
          {loading ? (
            <div className="h-32 mt-6 rounded-sm bg-gradient-to-r from-creamAlt via-cream to-creamAlt bg-[length:200%_100%] animate-shimmer" />
          ) : (
            <>
              <p className="font-serif italic text-2xl md:text-3xl text-oxblood leading-snug mt-6" data-testid="daily-quote">
                "{data?.quote}"
              </p>
              <p className="mt-4 text-sm text-cognac tracking-wide" data-testid="daily-quote-author">
                — {data?.quote_author}
              </p>
            </>
          )}
        </div>
        <div className="relative md:border-l md:border-gold/30 md:pl-12">
          <span className="label-overline flex items-center gap-2">
            <Sparkles size={12} className="text-gold" /> Financial fact of the day
          </span>
          {loading ? (
            <div className="h-32 mt-6 rounded-sm bg-gradient-to-r from-creamAlt via-cream to-creamAlt bg-[length:200%_100%] animate-shimmer" />
          ) : (
            <p className="font-serif text-xl md:text-2xl text-inkSoft leading-relaxed mt-6" data-testid="daily-fact">
              {data?.fact}
            </p>
          )}
          <p className="mt-6 text-[11px] tracking-[0.28em] uppercase text-inkMute">
            Refreshed daily · {data?.date}
          </p>
        </div>
      </div>
    </section>
  );
}
